<template>
  <div class="share-this-article__wrapper">
    <p class="share-this-article__title">
      Share this article
    </p>
    <div class="share-this-article__content">
      <div class="share-this-article__icons-wrapper">
        <a-action-icon
          v-for="item in actionIconList"
          v-bind="item.props"
          :key="item.icon"
          :action-icon="item.icon"
          :titleWidth="90"
          :aria-label="item.ariaLabel"
          :original="true"
          :color="$options.consts.ICON_COLOR.CUSTOM"
          v-on="$listeners"
        />
      </div>
      <a-preffered-source-cta class="share-this-article__preferred-source" />
    </div>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import AActionIcon, { ACTION_ICON } from 'shared/AActionIcon'
import { ARTICLE_EMAIL_SHARING_TEXT } from 'shared/ANewsItem'
import { ICON_COLOR } from 'shared/AIcon'
import APrefferedSourceCta from 'shared/APrefferedSourceCta'

export default {
  name: 'ArticleSocialIcons',
  mixins: [hydrationHelpers],
  components: { AActionIcon, APrefferedSourceCta },
  props: {
    article: propValidator([PROP_TYPES.OBJECT])
  },
  consts: { ICON_COLOR },
  computed: {
    actionIconList() {
      return [
        {
          icon: ACTION_ICON.TWITTER,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'Twitter'
        },
        {
          icon: ACTION_ICON.LINKED_IN,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'LinkedIn'
        },
        {
          icon: ACTION_ICON.EMAIL,
          props: {
            path: this.$route.path,
            title: ARTICLE_EMAIL_SHARING_TEXT.TITLE(this.article.title),
            description: ARTICLE_EMAIL_SHARING_TEXT.DESCRIPTION(
              `${this.$env.DOMAIN_URL}${this.$route.path}`
            )
          },
          ariaLabel: 'Email'
        },
        {
          icon: ACTION_ICON.TELEGRAM,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'Telegram'
        },
        {
          icon: ACTION_ICON.FACEBOOK,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'Facebook'
        },
        {
          icon: ACTION_ICON.LEARN_ABOUT,
          props: {
            term: this.article.mainTerm
          },
          ariaLabel: 'Learn About'
        },
        {
          icon: ACTION_ICON.WHATSAPP,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'WhatsApp'
        },
        ...(this.article.mainTag
          ? [
              {
                icon: ACTION_ICON.FOLLOW,
                props: {
                  tag: this.article.mainTag
                },
                id: 'article-icons-follow-tag-icon',
                ariaLabel: 'Follow'
              }
            ]
          : []),
        {
          icon: ACTION_ICON.REDDIT,
          props: {
            path: this.$route.path,
            title: this.article.title,
            description: this.$helper.parseTldrJSONToText(this.article.tldr)
          },
          ariaLabel: 'Reddit'
        },
        {
          icon: ACTION_ICON.SAVE,
          props: {
            isSaved: this.article.isSaved,
            id: this.article.id
          },
          ariaLabel: 'Save'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';
@import '~assets/scss/local/styles/article';

.share-this-article__wrapper {
  .share-this-article__title {
    @extend .section-subtitle;
  }

  .share-this-article__content {
    margin-top: 20px;
    display: flex;
    align-items: flex-start;

    @include mobile {
      flex-direction: column;
      align-items: center;
    }
  }

  .share-this-article__icons-wrapper {
    flex: 1;
    min-width: 0;

    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(auto-fit, 35px)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 15px
      ),
      $rowGapSetup: (
        $above-desktop-xl: 10px
      )
    );

    @include gridBuilder($grid-setup);

    @include mobile {
      flex: none;
      width: 100%;
      padding: 0 20px;
      justify-content: center;
    }
  }

  .share-this-article__preferred-source {
    flex-shrink: 0;
    margin-left: 16px;

    @include tablet {
      margin-left: 20px;
    }

    @include mobile {
      margin-left: 0;
      margin-top: 14px;
    }
  }
}
</style>
